import React from 'react'
import { ContentHeader } from '../../../components/Header/ContentHeader'
import { useFeatureFlags } from '../../../hooks/useFeatureFlags'

interface Props {
  // Add any props that might be needed for the header
}

const BudgetHeaderContainer: React.FC<Props> = () => {
  const { featureFlags, loading: featureFlagsLoading } = useFeatureFlags()

  // If feature flags are loading, return empty header
  if (featureFlagsLoading) {
    return <ContentHeader title='' color='#232C58' />
  }

  // If budget module is not enabled, return empty header
  if (!featureFlags?.budget_module_enabled) {
    return <ContentHeader title='' color='#232C58' />
  }

  return (
    <ContentHeader
      title={
        <span style={{ fontSize: '31.5px' }}>
          Study Budgeting
        </span>
      }
      color='#232C58'
    />
  )
}

export default BudgetHeaderContainer 